import { z } from 'zod';
import { AggregatorId, BrandId, ExternalPlayerId, InternalPlayerId, OperatorId } from './primitives.ts';

export const Operator = z.object({
  operatorId: OperatorId,
  aggregatorId: AggregatorId.optional(),
  displayName: z.string().min(1).max(128),
});
export type Operator = z.infer<typeof Operator>;

export const Brand = z.object({
  brandId: BrandId,
  operatorId: OperatorId,
  displayName: z.string().min(1).max(128),
});
export type Brand = z.infer<typeof Brand>;

/**
 * Tenant scope. Must be derived from authenticated credentials (launch session / API key),
 * never from a client-supplied operatorId.
 */
export const TenantContext = z.object({
  aggregatorId: AggregatorId.optional(),
  operatorId: OperatorId,
  brandId: BrandId,
});
export type TenantContext = z.infer<typeof TenantContext>;

export const PlayerRef = z.object({
  tenant: TenantContext,
  /** Unique only within operatorId scope. */
  externalPlayerId: ExternalPlayerId,
  internalPlayerId: InternalPlayerId,
});
export type PlayerRef = z.infer<typeof PlayerRef>;
